import React, {ReactNode} from 'react';

import Loading from '../../components/Loading';
import Button, {ButtonProps} from '../../components/Button';

import styles from './PaymentLayout.module.css';


interface PaymentLayoutProps {
  isLoading?: boolean
  children: ReactNode | ReactNode[]
  buttonProps: ButtonProps
  shouldShowButton?: boolean
}

const PaymentLayout = ({isLoading, shouldShowButton = true, children, buttonProps}: PaymentLayoutProps) => {

  if (isLoading) {
    return <Loading/>;
  }

  return (
    <div className={styles.root}>
      {children}
      {
        shouldShowButton ?
          <div className={styles.buttonContainer}>
            <Button
              loading={buttonProps.loading}
              disabled={buttonProps.disabled}
              onClick={buttonProps.onClick}
            >
              {buttonProps.children}
            </Button>
          </div>
          : null
      }
    </div>
  );
};

export default PaymentLayout;
